// Every event below carries includ_platform (APP / WEB, the same values as the order's
// includ_platform cart attribute): the file runs inside this function, whose gtag adds it
// to each 'event' call and passes the call on to the page's gtag. The app's in-app pages
// report to the web stream, so this is what tells their events apart there. An event
// parameter, not a user property, so Shopify's standard events are left as they are.
// Other commands ('set', …) pass through unchanged.
(function (gtag) {
// START : BANNER CLICKS
function cleanImageSrc(src) {
  if (!src) return '';
  try {
    const u = new URL(src, location.href);
    return u.origin + u.pathname;
  } catch (err) {
    return src.split('?')[0].split('#')[0];
  }
}

function computeBannerPosition(anchor, itemSelector) {
  if (!anchor) return null;
  const container =
    anchor.closest('.includ-hero-carousel__track') ||
    anchor.parentElement ||
    anchor.closest('[data-section-id]');
  if (!container) return null;

  const items = Array.from(container.querySelectorAll(itemSelector));
  const idx = items.indexOf(anchor);
  return idx === -1 ? null : idx + 1;
}

function computePickCategoryPosition(anchor) {
  if (!anchor) return null;
  const section = anchor.closest('.includ-pick-category');
  if (!section) return null;
  const activeGrid = section.querySelector('.includ-pick-category__grid--active');
  if (!activeGrid) return null;
  const items = Array.from(activeGrid.querySelectorAll('.includ-pick-category__item'));
  const idx = items.indexOf(anchor);
  return idx === -1 ? null : idx + 1;
}

function findSectionName(el) {
  if (!el) return null;

  const itemNames = [
    ['.includ-banner-carousel__banner', 'includ-banner-carousel-banner'],
    ['.shop-by-category-section', 'shop-by-category-scroll'],
    ['.includ-banner-carousel__card', 'includ-banner-carousel-scroll']
  ];

  for (const [selector, name] of itemNames) {
    if (el.closest(selector)) return name;
  }

  const SECTION_NAMES = [
    'includ-hero-carousel',
    'includ-category-grid',
    'includ-occasions',
    'includ-pick-category',
    'includ-shop-by-price',
    'includ-shop-by-age',
    'includ-banner-carousel',
    'collection-banner',
    'includ-store-carousel',
    'includ-pick-age',
    'includ-pick-gender'
  ];

  let cur = el;
  while (cur && cur !== document.documentElement) {
    for (const name of SECTION_NAMES) {
      if (cur.classList && cur.classList.contains(name)) return name;
    }
    cur = cur.parentElement;
  }
  return null;
}

function installClickEventCapture(e) {
  var cta = e.target.closest(
    '.announcement-bar__link, .includ-announcement__cta, .includ-footer__app-badges a , .available-offers__banner'
  );
  if (cta) {
    if (cta.classList.contains('includ-announcement__cta')) {
      gtag('event', 'install_click', {send_to: 'G-72RB76VELD'});
    } else if (cta.classList.contains('announcement-bar__link')) {
      gtag('event', 'install_click', {send_to: 'G-72RB76VELD'});
    } else if (cta.matches('.includ-footer__app-badges a')) {
      gtag('event', 'install_click', {send_to: 'G-72RB76VELD'});
    } else if (cta.matches('.available-offers__banner a')) {
      gtag('event', 'install_click', {send_to: 'G-72RB76VELD'});
    }
  }
}

function bannerClickEventCaptureByAnchor(e) {
  const anchor = e.target.closest('a');

  if (anchor && anchor.querySelector('img')) {
    const img = anchor.querySelector('img');
    const sectionName = findSectionName(anchor) || findSectionName(e.target);
    if (!sectionName) return;

    const bannerId = cleanImageSrc(img.currentSrc || img.src || '');

    let position = null;
    if (anchor.matches('.includ-hero-carousel__slide')) {
      position = computeBannerPosition(anchor, '.includ-hero-carousel__slide');
    } else if (anchor.matches('.includ-banner-carousel__banner')) {
      position = 1;
    } else if (anchor.closest('.includ-occasions__grid')) {
      position = computeBannerPosition(anchor, '.includ-occasions__card');
    } else if (anchor.closest('.includ-category-grid__container')) {
      position = computeBannerPosition(anchor, '.includ-category-grid__item');
    } else if (anchor.closest('.includ-shop-by-price__grid')) {
      position = computeBannerPosition(anchor, '.includ-shop-by-price__item');
    } else if (anchor.closest('.includ-shop-by-age__grid')) {
      position = computeBannerPosition(anchor, '.includ-shop-by-age__item');
    } else if (anchor.closest('.includ-pick-category')) {
      position = computePickCategoryPosition(anchor);
    } else if (anchor.closest('.includ-store-carousel__scroll')) {
      position = computeBannerPosition(anchor, '.includ-store-carousel__card');
    } else if (anchor.matches('.includ-banner-carousel__card')) {
      position = computeBannerPosition(anchor, '.includ-banner-carousel__card');
    }

    const payload = {
      send_to: 'G-72RB76VELD',
      section_name: sectionName,
      banner_id: bannerId
    };
    if (position !== null) payload.banner_position = position;
    if (typeof gtag === 'function') {
      gtag('event', 'banner_click', payload);
    }
  }
}

function bannerClickEventCaptureByButton(e) {
  const button = e.target.closest('button');
  if (button && (button.matches('.includ-pick-category__gender-tab') || button.matches('.includ-pick-category__age-tab'))) {
    const isGender = button.matches('.includ-pick-category__gender-tab');
    let sectionName = '';

    if (button.matches('.includ-pick-category__gender-tab')) {
      sectionName = 'includ-pick-category-gender';
    } else if (button.matches('.includ-pick-category__age-tab')) {
      sectionName = 'includ-pick-category-age';
    } else {
      return;
    }

    const position = isGender
      ? button.dataset.genderIndex != null ? Number(button.dataset.genderIndex) + 1 : null
      : button.dataset.ageIndex != null ? Number(button.dataset.ageIndex) + 1 : null;

    const payload = {
      send_to: 'G-72RB76VELD',
      section_name: sectionName,
      banner_id: button.textContent.trim()
    };

    if (position !== null) payload.banner_position = position;
    if (typeof gtag === 'function') {
      gtag('event', 'banner_click', payload);
    }
  }
}

function nearestCarousel(el) {
  return [
    '.resource-list__carousel',
    '.resource-list__scroll',
    '.product-recommendations',
    'product-recommendations',
    '.resource-list.hidden--desktop[ref="scroller"]'
  ].map(sel => el.closest(sel))
    .find(Boolean) || null;
}

function findCard(element) {
  return element.closest('product-card, .product-card, .resource-card, [data-product-id]') || null;
}

function computePosition(card, carousel) {
  if (!carousel || !card) return null;

  // Prefer the slide wrapper itself
  const slideWrapper = card.closest('slideshow-slide, .resource-list__slide');
  if (slideWrapper) {
    const parent = slideWrapper.parentElement;
    if (parent) {
      const allSlides = Array.from(parent.children).filter((child) =>
        child.matches('slideshow-slide, .resource-list__slide')
      );
      const idx = allSlides.indexOf(slideWrapper);
      return idx >= 0 ? idx + 1 : null;
    }
  }

  // Fallback: only count the top-level product/resource cards inside the carousel
  const topLevelCards = Array.from(carousel.querySelectorAll('[data-product-id]')).filter((item) => {
    return item.closest('product-card, .resource-card, [data-product-id]') === item;
  });

  const idx2 = topLevelCards.indexOf(card.closest('product-card, .resource-card, [data-product-id]') || card);
  return idx2 >= 0 ? idx2 + 1 : null;
}

function findSectionLabel(element) {
  
  const section = element.closest('section, [id^="shopify-section-"], product-recommendations, .product-recommendations, .includ-store-carousel, product-recommendations[data-intent="complementary"], .customer-reco');
  if (!section) return null;

  const headingSelectors = [
    '.section-heading',
    '.section__heading',
    '.includ-store-carousel__heading',
    '.product-recommendations__heading',
    '.includ-occasions__heading',
    '.includ-pick-category__heading',
    '.includ-shop-by-price__heading',
    '.includ-shop-by-age__heading',
    'h1',
    'h2',
    'h3'
  ];

  for (const selector of headingSelectors) {
    const heading = section.querySelector(selector);
    if (heading?.textContent?.trim()) {
      return heading.textContent.trim();
    }
  }
  return null;
}

function imgClickEventCapture(event) {
 const img = event.target.closest('.includ-pdp-gallery__thumb');
 if (!img) return;

 if (typeof gtag === 'function') {
    gtag('event', 'pdp_gallery_thumb_click', {
      send_to: 'G-72RB76VELD'
    });
  }
}

function recommendationProductClickEvent(event) {

  const clicked = event.target;

  const payload = {
    send_to: 'G-72RB76VELD',
    product_id: null,
    position: null,
    section_name: null
  };

  const simTile = clicked.closest('.simsw__tile'); // snippets/similar-swatch.liquid
  const swatch = clicked.closest('.cvs__swatch-item'); // sibling products on PDP

  if (simTile) {
    payload.product_id   = simTile.dataset.productId || null;
    payload.position     = Array.from(simTile.parentElement.children).indexOf(simTile) + 1;
    payload.section_name = 'similar_swatch';

  } else if (swatch) {
    const swatchList = swatch.parentElement;
    const allSwatches = swatchList
      ? Array.from(swatchList.children).filter(el => el.classList.contains('cvs__swatch-item'))
      : [swatch];

    payload.product_id   = swatch.dataset.productId || null;
    payload.position     = allSwatches.indexOf(swatch) + 1;
    payload.section_name = 'sibling_swatch';

  } else {
    const card = findCard(clicked);
    if (!card) return;

    const carousel = nearestCarousel(card);
    if (!carousel) return; // only handle recommendation/resource-list carousels

    payload.product_id   = card.dataset.productId || card.getAttribute('data-product-id') || null;
    payload.section_name = findSectionLabel(carousel) || null;
    payload.position     = computePosition(card, carousel);
  }

  if (!payload.section_name || !payload.position || !payload.product_id)
    return;

  if (typeof gtag === 'function') {
    gtag('event', 'recommendation_carousel_product_click', payload);
  }
}

// ── Cart V2 upsell rows (snippets/cart-upselling-widget.liquid) ──────────────
// V2 renders BOTH cart widgets from that one snippet, so the markup is identical
// for the empty-cart bestsellers row and the "Parents Also Bought" row. The only
// thing that tells them apart is the wrapper the snippet was rendered into:
//   .cart-v2__empty-wrap  → empty-cart bestsellers   (snippets/cart-v2-empty.liquid)
//   .cart-v2__body        → recommendations          (drawer + /cart page bodies)
// The two functions below each claim one of those, which keeps them mutually
// exclusive — a single click can never fire the event twice.
//
// Structure per card:
//   .cart-upsell__row > .cart-upsell__card[data-product-id] > product-card > …
// Product id is the plain numeric id on the card wrapper (no gid parsing, unlike
// V1 bestsellers), and position is indexed within the card's own row rather than
// a document lookup, because on V2 both rows use the same class and no id.
var CART_UPSELL_V2_IGNORE = [
  '.cart-upsell__add', // V2 "Add to Bag" — not a card tap; resolveCartUpsellV2Click reports it as action_name
  '.asp-includ-wl-btn', // wishlist V2 button
  '.asp-includ-wl-btn--card', // wishlist V2 wrapper
  '[data-spectrum-card-atc]', // V1 Spectrum ATC, in case product-card renders it
  '[data-spectrum-wl-mtb]' // V1 Spectrum wishlist
].join(', ');

// action_name for a tap on an Add / "+" button: the size sheet opens for
// anything with more than one variant ('choose_size'), else it adds ('add_to_bag').
function addActionName(button) {
  return button.hasAttribute('data-quick-shop-trigger') ? 'choose_size' : 'add_to_bag';
}

/**
 * Resolves a click inside a Cart V2 upsell row to its card payload.
 * @param {Event} e - The click event.
 * @param {boolean} wantEmptyState - true for the empty-cart bestsellers row, false for the recommendations row.
 * @returns {{product_id: string|null, position: number, action_name?: string}|null} Payload fields, or null when the click isn't a trackable card click.
 */
function resolveCartUpsellV2Click(e, wantEmptyState) {
  // "Add to Bag" is reported too, as action_name: 'add_to_bag' for a one-tap
  // add, 'choose_size' when it opens the quick-shop size drawer (a tap, so
  // intent; the drawer's own add is not tracked here).
  var add = e.target.closest('.cart-upsell__add');
  if (!add && e.target.closest(CART_UPSELL_V2_IGNORE)) return null;

  var card = e.target.closest('.cart-upsell__card');
  if (!card) return null;

  // Same cards, but the wishlist row reports itself (cartWishlistClickEvent).
  if (card.closest('[data-cart-wishlist-slot]')) return null;

  // Claim only the row this caller owns.
  var isEmptyState = !!card.closest('.cart-v2__empty-wrap');
  if (isEmptyState !== wantEmptyState) return null;

  var productId = card.dataset.productId || null;
  if (!productId) {
    var inner = card.querySelector('[data-product-id]');
    productId = inner ? inner.dataset.productId || null : null;
  }

  var row = card.closest('.cart-upsell__row');
  var cards = row ? Array.from(row.querySelectorAll('.cart-upsell__card')) : [];

  var result = {
    product_id: productId,
    position: cards.indexOf(card) + 1
  };
  if (add) result.action_name = addActionName(add);
  return result;
}

// Cart V2 "From Your Wishlist" row — app only (sections/cart-v2-wishlist.liquid).
// Same cards as the rows above, so the same event, as section_name
// 'cart_wishlist'. A tap on its Add button is sent too, with action_name
// 'add_to_bag' (one-variant, added) or 'choose_size' (opens the size sheet).
function cartWishlistClickEvent(e) {
  var card = e.target.closest('[data-cart-wishlist-slot] .cart-upsell__card');
  if (!card || typeof gtag !== 'function') return;

  var add = e.target.closest('.cart-upsell__add');
  if (!add && e.target.closest(CART_UPSELL_V2_IGNORE)) return;

  // Position among the cards on screen (products in the bag are hidden).
  var cards = Array.from(card.parentElement.children).filter(function (c) {
    return c.style.display !== 'none';
  });
  var payload = {
    send_to: 'G-72RB76VELD',
    product_id: card.dataset.productId || null,
    position: cards.indexOf(card) + 1,
    section_name: 'cart_wishlist'
  };
  if (add) payload.action_name = addActionName(add);
  gtag('event', 'recommendation_carousel_product_click', payload);
}

function cartBestSellerRecommendationProductClickEvent(e) {
  var productId = null;
  var position = null;

  var card = e.target.closest('.cart-bs__card');

  if (card) {
    // V1 — snippets/includ-cart-bestsellers.liquid
    if (e.target.closest('.cart-bs__atc')) return;

    var wlBtn = card.querySelector('[data-product-gid]');
    if (wlBtn) {
      var gid = wlBtn.dataset.productGid || '';
      var match = gid.match(/\/(\d+)$/);
      if (match) productId = match[1];
    }

    var scroll = card.closest('.cart-bs__scroll');
    var cards = scroll ? Array.from(scroll.querySelectorAll('.cart-bs__card')) : [];
    position = cards.indexOf(card) + 1;
  } else {
    // V2 — the bestsellers row inside .cart-v2__empty-wrap
    var v2 = resolveCartUpsellV2Click(e, true);
    if (!v2) return;

    productId = v2.product_id;
    position = v2.position;
  }

  if (typeof gtag === 'function') {
    var payload = {
      send_to: 'G-72RB76VELD',
      product_id: productId,
      position: position,
      section_name: 'cart_bestsellers'
    };
    if (v2 && v2.action_name) payload.action_name = v2.action_name;
    gtag('event', 'recommendation_carousel_product_click', payload);
  }
}

function navigationClickEventCapture(e){
   const hamburger = e.target.closest('[aria-label="Open categories"]');
   if (!hamburger) return;

   if (typeof gtag === 'function') {
    gtag('event', 'hamburger_clicks', {
      send_to: 'G-72RB76VELD'
    });
  }
};

function pdpFeatureClickEventCapture(e){
   
  if (e.target.closest('.ir-btn, .rv2-btn')){
    if (typeof gtag === 'function') {
        gtag('event', 'rating_preview_click', {
          send_to: 'G-72RB76VELD'
        });
      }
  } else if(e.target.closest('[href="#size-chart"]')) {
    if (typeof gtag === 'function') {
        gtag('event', 'size_chart_click', {
          send_to: 'G-72RB76VELD'
        });
      }
  } else if (e.target.closest('[href="#how-to-use"]')) {
   if (typeof gtag === 'function') {
      gtag('event', 'how_to_use_click', {
        send_to: 'G-72RB76VELD'
      });
    }
  } else if (e.target.closest('[aria-label="Share product"]')) {
    if (typeof gtag === 'function') {
      gtag('event', 'share_click', {
        send_to: 'G-72RB76VELD'
      });
    }
  } else if (e.target.closest('.edd-check-btn')){
    if (typeof gtag === 'function') {
      gtag('event', 'delivery_time_click', {
        send_to: 'G-72RB76VELD'
      });
    }
  } else if (e.target.closest('.includ-pdp-gallery__similar-text')){
    if (typeof gtag === 'function') {
      gtag('event', 'view_similar_click', {send_to: 'G-72RB76VELD'});
    }
  }
};

function infoIconClickEventCapture(e){
  const infoIcon = e.target.closest('.db__info-btn');

  if(!infoIcon) return;

  const iconName = infoIcon.getAttribute('aria-label') || 'unknown_info_icon';

  if (typeof gtag === 'function') {
    gtag('event', 'info_icon_click', {
      send_to: 'G-72RB76VELD',
      section_name: iconName 
    });
  }
}

function cartRecommendationProductClickEvent(e) {
  var productId = null;
  var position = null;

  var card = e.target.closest('.cart-drawer-collection__card');

  if (card) {
    // V1 — snippets/cart-drawer-collection.liquid
    if (e.target.closest('[data-spectrum-card-atc], [data-spectrum-wl-mtb], .cart-drawer-card-atc')) return;

    var rendered = card.querySelector('[data-product-id]');
    productId = rendered ? rendered.dataset.productId : null;

    var scroll = document.getElementById('CartDrawerCollection-Scroll');
    var allCards = scroll ? Array.from(scroll.querySelectorAll('.cart-drawer-collection__card')) : [];
    position = allCards.indexOf(card) + 1;
  } else {
    // V2 — the upsell row inside .cart-v2__body (drawer and /cart page alike)
    var v2 = resolveCartUpsellV2Click(e, false);
    if (!v2) return;

    productId = v2.product_id;
    position = v2.position;
  }

  if (typeof gtag === 'function') {
    var payload = {
      send_to: 'G-72RB76VELD',
      product_id: productId,
      position: position,
      section_name: 'cart_drawer_collection'
    };
    if (v2 && v2.action_name) payload.action_name = v2.action_name;
    gtag('event', 'recommendation_carousel_product_click', payload);
  }
}

// includ engagement rail — a reel card tapped in the widget (home / PDP)
function reelWidgetClickEventCapture(e) {
  // Rail cards are <a class="video-card"> inside .includ-engagement-rail. Scope
  // to the rail so the Instagram widget (same .video-card class) isn't captured.
  var card = e.target.closest('.includ-engagement-rail a.video-card');
  if (!card) return;

  if (typeof gtag === 'function') {
    gtag('event', 'reel_widget_click', { send_to: 'G-72RB76VELD' });
  }
}

document.addEventListener('click', function (e) {

  setTimeout(() => installClickEventCapture(e), 0);
  setTimeout(() => bannerClickEventCaptureByAnchor(e), 0);
  setTimeout(() => bannerClickEventCaptureByButton(e), 0);

  setTimeout(() => recommendationProductClickEvent(e), 0);
  setTimeout(() => cartRecommendationProductClickEvent(e), 0);
  setTimeout(() => cartBestSellerRecommendationProductClickEvent(e), 0);
  setTimeout(() => cartWishlistClickEvent(e), 0);

  setTimeout(() => imgClickEventCapture(e), 0);

  setTimeout(() => navigationClickEventCapture(e), 0);
  setTimeout(() => pdpFeatureClickEventCapture(e), 0);
  setTimeout(() => infoIconClickEventCapture(e), 0);

  setTimeout(() => reelWidgetClickEventCapture(e), 0);
});

// sort applied
document.addEventListener('change', function (e) {
  var radio = e.target.closest('.sort-drawer__radio-input');
  if (!radio) return;
  if (typeof gtag === 'function') {
    gtag('event', 'sort_applied', {send_to: 'G-72RB76VELD'});
  }
});

// filter applied
document.addEventListener('filter:update', function (event) {
  if (typeof gtag === 'function') {
    gtag('event', 'filter_applied', {send_to: 'G-72RB76VELD'});
  }
});

// add/remove wishlist
document.addEventListener('spectrum:wishlist:updated', function (event) {
  if (event.detail && event.detail.action) {
    if (typeof gtag === 'function') {
      gtag('event', 'wishlist_' + event.detail.action, {send_to: 'G-72RB76VELD'});
    }
  }
});

// add/remove wishlist (V2 custom backend)
// Action names are normalised to match the V1 events above ('added'/'removed')
// so existing GA reports stay comparable across both wishlist versions.
document.addEventListener('wishlist:v2:updated', function (event) {
  if (typeof gtag !== 'function') return;
  if (!event.detail || !event.detail.action) return;

  var action = event.detail.action;
  if (action === 'remove') action = 'removed';

  var payload = {send_to: 'G-72RB76VELD'};
  if (event.detail.productId) 
    payload.product_id = String(event.detail.productId);
  if (typeof event.detail.count === 'number') 
    payload.wishlist_count = event.detail.count;

  gtag('event', 'wishlist_' + action, payload);
});

// reels player actions (emitted by includ-engagement.js)
document.addEventListener('reels_action', function (event) {
  if (typeof gtag !== 'function' || !event.detail) return;
  var d = event.detail;
  var payload = {
    send_to: 'G-72RB76VELD',
    action_name: d.action_name,
    reel_id: d.reel_id
  };
  if (d.tag_name != null) payload.tag_name = d.tag_name; // only on video_hashtag_click
  gtag('event', 'reels_action', payload);
});

// A/B similar swatch (snippets/similar-swatch.liquid): the block reached the screen, in
// both groups. The visible element is the Colors block in ctrl and the similar row in var1;
// mobile widths only, as the test is. This is what counts the browser in the experiment.
(function () {
  function watch() {
    var row = document.querySelector('.simsw');
    var id = row && row.dataset.exp;
    if (!id || !window.includExp || !window.includExp.variant(id)) return;
    if (!window.matchMedia('(max-width: 749px)').matches || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      observer.disconnect();
      // The app's bridge can land after this file ran: variant() is null again by now.
      var group = window.includExp.variant(id);
      if (!group) return;
      window.includExp.expose(id);
      if (typeof gtag === 'function') {
        gtag('event', 'similar_swatch_position_seen', {
          send_to: 'G-72RB76VELD',
          section_name: 'similar_swatch',
          variant: group
        });
      }
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-exp="' + id + '"]').forEach(function (el) { observer.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

// A/B groups (snippets/experiments.liquid; nothing runs without it). Web only: the app's
// in-app pages count as web sessions in GA, so the app sends no group to GA (its groups
// reach the order through the exps cart attribute, assets/cart-v2-service.js).
// - user property exps: GA applies it to that browser's events, including the page
//   views, add to carts and purchases Shopify's Google app sends;
// - exp_active on every page load: marks the session, for sessions per group.
// When this browser's web experiments have all ended, the user property is cleared once.
// Pushed straight onto the GA queue (Arguments objects, as gtag's own stub does): the
// Google app's gtag may not exist yet when this deferred file runs, and the queue is read
// when it loads. exp_active names includ_platform itself, as the wrapper below would.
(function () {
  if (!window.includExp || window.includIsApp) return;
  window.dataLayer = window.dataLayer || [];
  function queue() { window.dataLayer.push(arguments); }
  var tag = window.includExp.tag();
  var KEY = 'inc_exp_ga';
  var last = '';
  try { last = window.localStorage.getItem(KEY) || ''; } catch (e) {}
  function publish(exps) {
    queue('set', 'user_properties', { exps: exps });
    try { window.localStorage.setItem(KEY, exps); } catch (e) {}
    // By load the app's bridge has usually landed: a page that turned out to be the app
    // (its first launch, before the app flag is remembered) takes the group back off.
    function active() {
      if (window.includIsApp) {
        queue('set', 'user_properties', { exps: null });
        try { window.localStorage.removeItem(KEY); } catch (e) {}
        return;
      }
      queue('event', 'exp_active', { exps: exps, send_to: 'G-72RB76VELD', includ_platform: 'WEB' });
    }
    if (document.readyState === 'complete') active();
    else window.addEventListener('load', active);
  }
  // A browser counted mid-page: its group reaches GA now, not on the next page load.
  document.addEventListener('includ:exp-exposed', function () { publish(window.includExp.tag()); });
  if (!tag) {
    if (last) {
      queue('set', 'user_properties', { exps: null });
      try { window.localStorage.removeItem(KEY); } catch (e) {}
    }
    return;
  }
  publish(tag);
})();
})(function (cmd, name, params) {
  if (typeof window.gtag !== 'function') return;
  if (cmd !== 'event') return window.gtag.apply(window, arguments);
  window.gtag(cmd, name, Object.assign({}, params, { includ_platform: window.includIsApp ? 'APP' : 'WEB' }));
});
